import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-emi-calculator',
  templateUrl: './emi-calculator.component.html',
  styleUrls: ['./emi-calculator.component.scss']
})
export class EmiCalculatorComponent implements OnInit,OnChanges {
  @Input() productPrice: any;
  @Input() loan: any;
  newProductPrice:any
  downPaymentPrice:any =0;
  updateFlag = false;
  userInterest: any = 15;
  userYear: any = 5;
  userMonths: any = 1;
  result: any = {
    emi: "",
    interest: "",
    total: ""
  }
  loanAmount: number = 0;
  downPayment:any = 0;
  loanAmountOptions = {
    floor: 100000,
    ceil: 8000000,
  };

  remi: any = {
    value: 15
  }
  temi: any = {
    value: 5
  }

  price:any;
  constructor() {
  }

  ngOnInit(): void {
    this.productPrice = this.productPrice ? this.productPrice : this.loanAmountOptions.floor;
    this.newProductPrice = this.productPrice;
    this.price = this.productPrice
    this.calculateEmi();
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    title: {
      text: ''
    },
    legend: {
      enabled: true,
    },
    plotOptions: {
      pie: {

        dataLabels: {
          enabled: false,
          distance: -50,
          style: {
            fontWeight: 'bold',
            color: 'white'
          }
        },
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%'],
        size: '100%'
      }
    },
    colors: [
      '#ADCCF3',
      '#307FE2',
    ],
    chart: {
      width: 320,
      height: 250,
    },

    series: [
      {
        type: 'pie',
        name: '',
        innerSize: '50%',
        data: [
          [
            'Principal amount', 0,
          ],
          [
            'Interest amount', 1,
          ],

        ]
      },
    ],
    responsive: {
      rules: [{
          condition: {
              maxWidth: 991
          },
          chartOptions: {
              chart: {
                width: 250,
              }
          }
      }]
  }
  };
  valueChange(value:any,event:any) {
    if(value == 0 || value == null || value == undefined){
      this.loan = '';
      this.productPrice = '';
      this.downPayment =0;
      this.downPaymentPrice = 0;
      event.stopPropagation();
      event.preventDefault();
      if(value == 0){
      this.productPrice = this.price;
      this.loan = this.price;
      }
      this.calculateEmi();

    } else if (value == '') {
      this.loan = '';
      this.productPrice = '';
      this.downPayment = 0;
      this.downPaymentPrice = 0;
      event.stopPropagation();
      event.preventDefault();
    } else if (value > 10000000) {
      this.loan = '10000000';
      this.productPrice = 10000000;
      this.downPayment = 0;
      this.downPaymentPrice = 0;
      this.calculateEmi()
    } else {
      this.loan = value;
      this.productPrice = value;
      this.downPayment = 0;
      this.downPaymentPrice = 0;
      this.calculateEmi();
    }

  }
  valueChangeDownPayment(value:any,event:any) {
    if(value == 0 || value == null || value == undefined){
      this.downPayment = 0;
      this.downPaymentPrice = 0;
      this.calculateEmi();
    } else if (value == '') {
      this.downPayment = '';
      this.downPaymentPrice = '';
      event.stopPropagation();
      event.preventDefault();
    } else if (value > 10000000) {
      this.downPayment = '10000000';
      this.downPaymentPrice = 0;
      this.calculateEmi()
    } else {
      if(value > this.productPrice){
        this.downPayment = 0;
      this.downPaymentPrice = 0;
      event.stopPropagation();
      event.preventDefault();
      }else{
      this.downPayment = value;
      this.downPaymentPrice = value;
      this.calculateEmi();
    }
    }
  }

  intersetchange(value: any,event: any){
    if (value == null){
      this.valueChangeInterest(15,event);
    }
  }
  valueChangeInterest(value: any, event: any) {

    if (value == 0 || value == null || value == undefined) {
      this.remi.value = '';
      if (value == null){
      }
      if (value == 0){
      this.userInterest = 15;
      this.remi.value = '15';
      }
      event.stopPropagation();
      event.preventDefault();
    } else if (value == '') {

      this.remi.value = '';
      event.stopPropagation();
      event.preventDefault();
    } else if (value > 20) {
      this.remi.value = '20';
      this.userInterest = 20;
      this.calculateEmi()
    } else {
      this.remi.value = value;
      this.userInterest = value;
      this.calculateEmi()
    }

  }

  valueChangeYear(value: any, event: any) {
    if (value == 0 || value == null || value == undefined) {
      this.temi.value = '';
      this.userYear = '';
      event.stopPropagation();
      event.preventDefault();
    } else if (value == '') {
      this.temi.value = '';
      this.userYear = '';
      event.stopPropagation();
      event.preventDefault();
    } else if (value > 20) {
      this.temi.value = '5';
      this.userYear = 20;
      this.calculateEmi()
    } else {
      this.temi.value = value;
      this.userYear = value;
      this.calculateEmi()
    }

  }
  calculateEmi() {

    let loanAmount = this.productPrice > 0 ? this.productPrice : Number(this.productPrice) && this.productPrice >= this.loanAmountOptions.floor && this.productPrice <= this.loanAmountOptions.ceil ? Number(this.productPrice) : this.loanAmountOptions.floor;
    let downPayAmount = this.downPaymentPrice > 0 ? this.downPaymentPrice :
    Number(this.downPaymentPrice) && this.downPaymentPrice >= this.loanAmountOptions.floor &&
    this.downPaymentPrice <= this.loanAmountOptions.ceil ? Number(this.downPaymentPrice) : this.downPaymentPrice;
    let numberOfMonths = (Number(this.temi.value) * 12);
    let rateOfInterest = Number(this.remi.value);
    this.userInterest = this.remi.value;
    let monthlyInterestRatio = (rateOfInterest / 100) / 12;
    this.productPrice = loanAmount;
    this.downPaymentPrice = downPayAmount
    this.userYear = this.getYears(this.temi.value);
    this.userMonths = this.getMonths(this.temi.value);
    let top = Math.pow((1 + monthlyInterestRatio), numberOfMonths);
    let bottom = top - 1;
    let sp = top / bottom;
    let mainLoanAmount = loanAmount - downPayAmount
    let emi = ((mainLoanAmount * monthlyInterestRatio) * sp);
    let full = numberOfMonths * emi;
    let interest = full - mainLoanAmount;
    this.newProductPrice = mainLoanAmount;
    this.result.emi = this.convertToIndianFormat(emi.toFixed(0));
    this.result.total = this.convertToIndianFormat(full.toFixed(0));
    this.result.interest = this.convertToIndianFormat(interest.toFixed(0));
    this.chartOptions = {
                    title: {
                      text: ''
                    },
                    credits: {
                      enabled: false,
                    },
                    legend: {
                      enabled: true,
                    },
                    plotOptions: {
                      pie: {

                        dataLabels: {
                          enabled: false,
                          distance: -50,
                          style: {
                            fontWeight: 'bold',
                            color: 'white'
                          }
                        },
                        startAngle: -90,
                        endAngle: 90,
                        center: ['50%', '75%'],
                        size: '110%'
                      }
                    },
                    colors: [
                      '#ADCCF3',
                      '#307FE2',
                    ],
                    chart: {
                      width: 320,
                      height: 250,
                    },
                    series: [
                      {
                        type: 'pie',
                        name: '',
                        innerSize: '50%',
                        data: [
                          [
                            'Principal amount', this.newProductPrice,
                          ],
                          [
                            'Interest amount', Math.round(interest),
                          ],

                        ]
                      },
                    ],
                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 991
                            },
                            chartOptions: {
                                chart: {
                                  width: 250,
                                }
                            }
                        }]
                    }
  }

  }


  handleUpdate() {
    this.updateFlag = true;
  }
  getYears(n: any) {
    let newNum = (n + "").split(".")
    return newNum[0] ? Number(newNum[0]) : 0
  }
  getMonths(n: any) {
    let newNum = (n + "").split(".")
    return newNum[1] ? Number(newNum[1]) : 0
  }
  convertToIndianFormat(amount: any) {
    let x = amount.toString();
    var lastThree = x.substring(x?.length - 3);
    var otherNumbers = x.substring(0, x?.length - 3);
    if (otherNumbers != '')
      lastThree = ',' + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['productPrice'] && !changes['productPrice'].firstChange) {
      const newSpecification = changes['productPrice'].currentValue;
      this.productPrice=newSpecification
      this.newProductPrice=newSpecification
      this.calculateEmi()
    }
  }
}
